/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PccPendingPatient } from './PccPendingPatient';
import {
    PccPendingPatientFromJSON,
    PccPendingPatientFromJSONTyped,
    PccPendingPatientToJSON,
    PccPendingPatientToJSONTyped,
} from './PccPendingPatient';

/**
 * 
 * @export
 * @interface FindOnePccPendingPatient200Response
 */
export interface FindOnePccPendingPatient200Response {
    /**
     * 
     */
    data?: PccPendingPatient;
}

/**
 * Check if a given object implements the FindOnePccPendingPatient200Response interface.
 */
export function instanceOfFindOnePccPendingPatient200Response(value: object): value is FindOnePccPendingPatient200Response {
    return true;
}

export function FindOnePccPendingPatient200ResponseFromJSON(json: any): FindOnePccPendingPatient200Response {
    return FindOnePccPendingPatient200ResponseFromJSONTyped(json, false);
}

export function FindOnePccPendingPatient200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOnePccPendingPatient200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PccPendingPatientFromJSON(json['data']),
    };
}

export function FindOnePccPendingPatient200ResponseToJSON(json: any): FindOnePccPendingPatient200Response {
    return FindOnePccPendingPatient200ResponseToJSONTyped(json, false);
}

export function FindOnePccPendingPatient200ResponseToJSONTyped(value?: FindOnePccPendingPatient200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PccPendingPatientToJSON(value['data']),
    };
}

